import { React, models, kea, history, resources, selectores, componentToRx } from "app/main/std";
import { UsuarioRow } from "./usuariorow";
import { onCerrarSesion } from "app/logic/login";
import { DescargarAPKButton } from "app/features/inicio/apk";

interface LoginModel {
    user: string;
    password: string;
}

export interface Props {
    value: LoginModel;
    onChange: (value: LoginModel) => PromiseLike<void>;
}


/**
 * Componente para editar un LoginModel
 */
class LoginForm extends React.PureComponent<Props> {
    getFields = kea.formfields(() => this.props);

    private onEntrar = async () => {
        const value = this.props.value;
        const ok = await resources.User.login(value.user, value.password);
        if (!ok) {
            await kea.message("Login incorrecto", "El usuario o la contraseña están incorrectos", "error");
        } else {
            history.go("/operativa");
        }
    }

    render() {
        const { value } = this.props;
        const getField = this.getFields;
        const Text = getField(kea.Text);
        const Password = getField(kea.Password);

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                Login
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <UsuarioRow onCerrarSesion={onCerrarSesion} />
                                    </div>
                                </div>
                                <hr />


                                <div className="row">
                                    <div className="col-md-12">
                                        <Text field="user" addon={<i className="fa fa-user fa-fw" />} label="Usuario" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <Password field="password" addon={<i className="fa fa-lock fa-fw" />} label="Contraseña" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <kea.Button style="success" iconClass="fa fa-check fa-fw" onClick={this.onEntrar}>
                                            Entrar
                                        </kea.Button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DescargarAPKButton />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export const Login = kea.makeUncontrolled<Props>("value", "onChange", {})(LoginForm);


// WEBPACK FOOTER //
// ./app/features/general/login/index.tsx